export default function EmptyLienWaiverIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* document body */}
      <rect
        x="10"
        y="8"
        width="38"
        height="48"
        rx="3"
        fill="currentColor"
        opacity="0.08"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      {/* folded corner */}
      <path
        d="M36 8 L48 20 L36 20 Z"
        fill="currentColor"
        opacity="0.15"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      {/* seal / stamp circle */}
      <circle
        cx="29"
        cy="38"
        r="10"
        fill="currentColor"
        opacity="0.06"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeDasharray="3 2"
      />
      {/* inner seal ring */}
      <circle
        cx="29"
        cy="38"
        r="6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        opacity="0.4"
      />
      {/* text lines on doc */}
      <line
        x1="16"
        y1="23"
        x2="34"
        y2="23"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="16"
        y1="28"
        x2="34"
        y2="28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* missing / slash badge */}
      <circle
        cx="48"
        cy="48"
        r="11"
        fill="var(--bg2, #fff)"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <line
        x1="43"
        y1="43"
        x2="53"
        y2="53"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="53"
        y1="43"
        x2="43"
        y2="53"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
